module.exports = __webpack_public_path__ + "img/thaw-gallery.bf17bbef.jpg";